import { useInitData } from '../../../hooks'
import { BirdviewCard } from '../BirdviewCard'
import { BirdviewCommunicationRow } from '../BirdviewCommunicationRow'
import { BIRDVIEW_SECTION_TARGET } from '../DashboardBirdview.constants.targets'
import { useBirdviewListTarget } from '../DashboardBirdview.hooks'
import { getBirdviewCommunicationPathname } from '../DashboardBirdview.utils.targets'

function BirdviewCommunicationWidget({
  dragHandleProps,
  section,
  title,
  onNavigate,
}) {
  const { availableSections } = useInitData()
  const { getListTarget } = useBirdviewListTarget()

  function handleShowAll(event) {
    onNavigate({
      event,
      link: getListTarget(BIRDVIEW_SECTION_TARGET.communication),
    })
  }

  function handleOpen({ event, item }) {
    onNavigate({
      event,
      link: getBirdviewCommunicationPathname({ availableSections, item }),
    })
  }

  return (
    <BirdviewCard
      count={section.total}
      dragHandleProps={dragHandleProps}
      hasMore={section.hasMore}
      isRefreshing={section.isRefreshing}
      skeletonProps={{ hasSubtitle: false }}
      state={section.state}
      title={title}
      onRetry={section.reload}
      onShowAll={handleShowAll}
    >
      {section.items.map(item => (
        <BirdviewCommunicationRow
          item={item}
          key={item.id}
          onOpen={handleOpen}
        />
      ))}
    </BirdviewCard>
  )
}

export default BirdviewCommunicationWidget
